export const images = [
    {
      id: '01',
      src: '/stadium 01.jpg',
      alt: 'Whitney',
    },
    {
      id: '02',
      src: '/stadium 02.jpg',
      alt: 'Whitney',
    },
    {
      id: '03',
      src: '/stadium 03.jpg',
      alt: 'Whitney',
    },
    {
      id: '04',
      src: '/stadium 04.jpg',
      alt: 'Whitney',
    },
    {
        id: '04',
        src: '/stadium 05.jpg',
        alt: 'Whitney',
      },
      {
        id: '04',
        src: '/stadium 06.jpg',
        alt: 'Whitney',
      },
      {
        id: '04',
        src: '/stadium 07.jpg',
        alt: 'Whitney',
      },
      {
        id: '04',
        src: '/stadium 08.jpg',
        alt: 'Whitney',
      },  
      {
        id: '04',
        src: '/stadium 09.jpg',
        alt: 'Whitney',
      },  
      {
        id: '04',
        src: '/stadium 10.jpg',
        alt: 'Whitney',
      },           
  ]